import { ProgressBar } from "react-bootstrap";
import React from "react";
import smartPercentCalculator from "helpers/smart-percent-calculator";

const getProgressBar = (condition, children = null) => {
  // 3.63 yellow
  // 4,22 green
  // 3,57 red
  let className = "";
  if (condition && condition.voltage) {
    const { voltage } = condition;
    if (Number(voltage) > 3.63 && Number(voltage) <= 4.22) {
      className = "success";
    } else if (Number(voltage) > 3.57 && Number(voltage) <= 3.63) {
      className = "warning";
    } else if (Number(voltage) <= 3.57) {
      className = "danger";
    }
    const percent = smartPercentCalculator(2, 4.22, Number(voltage));

    return (
      <div className="position-relative w-100" style={{
        height: 20
      }}>
        <div
          className="w-100 h-100  position-absolute text-center"
          style={{
            color: "#fff",
            textShadow: "1px 1px 2px #000",
            lineHeight: 1
          }}
        >
          {Number(voltage)} {children}
        </div>
        <ProgressBar
          animated
          variant={className}
          now={percent}
          className="border"
        />
      </div>
    );
  }
  return false;
};

export default getProgressBar;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/helpers/get-progress-bar.js